import { GenericService } from './generic.service';
import { Injectable } from '@angular/core';
import { YoutubeCategoryAdapter, YoutubeCategory } from '../../shared/models/sapi/youtube-category.model';

@Injectable({
	providedIn: 'root'
})
export class YoutubeCategoryService extends GenericService<YoutubeCategoryAdapter, YoutubeCategory> {
	apiPath = 'youtubecategory';

	constructor(public youtubeCategoryAdapter: YoutubeCategoryAdapter) {
		super(youtubeCategoryAdapter);
	}
}
